define('ch_search',['ch_utils'], function ({ debounce }) {
    // initialize the view
    if (!window.Filters) {
        window.Filters = {};
    }

    // @todo make them ids
    const searchForm = document.querySelector('.js-search-form');
    const searchField = document.querySelector('.js-search-by-keyword input');
    const resultsElement = document.getElementById('header-search-results');
    const maxResult = 10;

    const mobileSearchButton = document.getElementById('js-mobile-search');
    const mobileSearchForm = document.getElementById('mobile-search-section');

    const removedSearchTermsExpr = new RegExp([
        'class',
        'classes',
        'course',
        'courses',
        'training',
        'workshop',
    ].map((word) => `\\b${word}\\b`).join('|'), 'ig');

    const debouncedRenderSuggestions = debounce(renderSuggestions, 200);

    // the "exact match" is a shortcut to link directly to a category
    // instead of submitting a keyword search upon submission
    let exactCategoryMatch;

    // Sequence number for suggestion renders. The endpoint can take most of a second while
    // input is debounced at 200ms, so a response routinely arrives after the user has typed
    // again. Without this, a slow reply for "sql" repaints the menu after a newer keystroke
    // already cleared it, which is the same stale-results symptom by a different route.
    let latestRenderToken = 0;

    // deal with displaying the mobile search field as well...
    if (mobileSearchButton && mobileSearchForm) {
        // Collapse the bar here rather than in the template: some responsive
        // pages include the menu bar but never execute this module, and there
        // the bar must stay visible as a plain working form.
        mobileSearchForm.setAttribute('hidden', '');
        mobileSearchButton.setAttribute('aria-expanded', 'false');
        mobileSearchButton.addEventListener('click', () => {
            const isHidden = mobileSearchForm.toggleAttribute('hidden');
            mobileSearchButton.setAttribute('aria-expanded', String(!isHidden));
            if (!isHidden) {
                const mobileSearchInput = mobileSearchForm.querySelector('input[name="kw"]');
                if (mobileSearchInput) {
                    mobileSearchInput.focus();
                }
            }
        });
    }

    // set defaults
    if (searchField) {
        searchField.value = Filters.kw || '';

        // @todo debounce
        // @todo fetch polyfill
        searchField.addEventListener('input', function (e) {
            const value = searchField.value.replace(removedSearchTermsExpr, '');

            exactCategoryMatch = null;

            debouncedRenderSuggestions(value);
        });
    }

    if (searchForm) {
        // when a user submits their search term in full
        searchForm.addEventListener('submit', function (e) {
            if (exactCategoryMatch && exactCategoryMatch.url) {
                e.preventDefault();
                window.location = exactCategoryMatch.url;
                return;
            }
            else {
                e.preventDefault();
                const value = searchField.value.replace(removedSearchTermsExpr, '');

                // Try one more last before submitting:
                // Two-argument .then rather than a trailing .catch, so a throw inside the
                // success handler cannot also hit the failure handler and submit twice.
                renderSuggestions(value).then(
                    () => {
                        if (exactCategoryMatch && exactCategoryMatch.url) {
                            window.location = exactCategoryMatch.url;
                            return;
                        }
                        searchForm.submit();
                    },
                    () => {
                        // Never strand the user. The native submit was already cancelled
                        // above, so if the suggestions request fails there is nothing left
                        // to carry out the search unless we do it here: the Search button
                        // and the Enter key would otherwise do nothing at all.
                        searchForm.submit();
                    }
                )
            }
        });

        // when a user clicks a thing in the result list
        searchForm.addEventListener('click', function (e) {
            if (e.target.classList.contains('ui-menu-item-wrapper')) {

            }
        });

        searchForm.addEventListener('focus', function (e) {
            if (target.matches('input')) {

            }
        });
    }

    // Two characters, not three. "AI" is a real category and a real search, and at the old
    // threshold typing it did nothing at all: renderSuggestions returned before touching the
    // results element, so the dropdown kept showing whatever the PREVIOUS query had rendered.
    // Typing "sql" then replacing it with "ai" left the SQL results sitting under the box.
    const minSuggestionLength = 2;

    async function renderSuggestions(value, inheritedToken) {
        // A retry INHERITS its parent's token rather than taking a new one. Allocating a
        // fresh number per retry broke the invariant the paint guard depends on, that the
        // highest token is the newest thing the visitor asked for: an abandoned query's
        // retry is issued later in wall-clock time than a newer keystroke, so it claimed the
        // higher number and the newer, correct results were then discarded unpainted.
        // Shortening the box while a zero-result query was still in flight showed this.
        const token = inheritedToken === undefined ? ++latestRenderToken : inheritedToken;
        const trimmed = value ? value.trim() : '';

        // Below the threshold, clear the box instead of leaving stale results visible.
        // This is the half of the bug that made short queries look wrong rather than empty.
        if (trimmed.length < minSuggestionLength) {
            exactCategoryMatch = null;
            if (resultsElement) {
                resultsElement.innerHTML = '';
                resultsElement.style.display = 'none';
            }
            return;
        }

        if (value && trimmed.length >= minSuggestionLength) {
            const data = await fetchSearchSuggestions(value)

            const valueHasSpaces = !!value.match(/\s/g);
            const valueEndsInS = value.toLowerCase().endsWith('s');
            const valueHasAndWord = !!value.match(/\sand\s/g);
            if (token === latestRenderToken) {
                resultsElement.innerHTML = '';
            }
            let result = '';

            const categories = data.data.filter((el) => el.section === 'Category');
            const classes = data.data.filter((el) => el.section === 'Course');
            const schools = data.data.filter((el) => el.section === 'School');

            // Each retry below re-enters this function with a shortened term, so it has to
            // stay long enough to be searched. Without this guard the singular retry takes
            // a two-character query down to one, which lands in the too-short branch at the
            // top and BLANKS the menu: typing "js" cleared the dropdown entirely instead of
            // offering "Press enter to search by keyword", because "js" finds nothing, ends
            // in an s, and "j" is below the minimum.
            const canRetryWith = (candidate) => candidate.trim().length >= minSuggestionLength;

            // Try search suggestion request without spaces if no results are returned. I.e. try "sketchup" if the user types "sketch up" with no results.
            if (valueHasSpaces && data.data.length === 0 && canRetryWith(value.replace(/\s/g, ''))) {
                return await renderSuggestions(value.replace(/\s/g, ''), token);
            }

            // Try substituting " and " with " & " if there are no categories
            if (valueHasAndWord && categories.length === 0 && canRetryWith(value.replace(/\sand\s/g, ' & '))) {
                return await renderSuggestions(value.replace(/\sand\s/g, ' & '), token);
            }

            // Try again without last s if no categories ("singular" version of search term)
            if (valueEndsInS && categories.length === 0 && canRetryWith(value.slice(0, -1))) {
                return await renderSuggestions(value.slice(0, -1), token);
            }

            if (data.data.length === 0) {
                result += 'Press "enter" to search by keyword.';
            } else {
                result += '<ul class="ui-menu ui-widget ui-widget-content ui-autocomplete ui-front">';

                data.data.splice(maxResult);


                if (categories.length) {
                    result += '<li class="ui-autocomplete-section">Categories</li>';
                    result += categories.reduce((prev, el) => `${prev}<li class="ui-menu-item">
                        <a class="ui-menu-item-wrapper result" data-type="Category" href="${el.url}">
                            ${el.label}
                        </a>
                    </li>`, '');

                    exactCategoryMatch = categories.find((category) => category.label.toLowerCase() === value.trim().toLowerCase());


                    // Try again with "plural" version of search term (yeah, yeah, I know many plurals just add an 's')
                    if (!exactCategoryMatch) {
                        exactCategoryMatch = categories
                            .find((category) => category.label.toLowerCase() === value.trim().toLowerCase() + 's');
                    }
                } else {
                    exactCategoryMatch = null;
                }

                if (classes.length) {
                    result += '<li class="ui-autocomplete-section">Courses</li>';
                    result += classes.reduce((prev, el) => `${prev}<li class="ui-menu-item">
                        <a class="ui-menu-item-wrapper result" data-type="Course" href="${el.url}">
                            ${el.label}
                        </a>
                    </li>`, '')
                }

                if (schools.length) {
                    result += '<li class="ui-autocomplete-section">Schools</li>';
                    result += schools.reduce((prev, el) => `${prev}<li class="ui-menu-item">
                        <a class="ui-menu-item-wrapper result" data-type="School" href="${el.url}">
                            ${el.label}
                        </a>
                    </li>`, '');
                }

                result += '</ul>';
            }

            // Only the newest render may paint. A stale response must not resurrect a
            // menu that a newer keystroke already cleared or replaced.
            if (token === latestRenderToken) {
                resultsElement.innerHTML = result;
                resultsElement.style.display = 'block';
            }
        }
    }


    async function fetchSearchSuggestions(value) {
        // Always resolves to a well-formed payload. Previously a non-ok response resolved
        // to undefined and the next .then dereferenced it, and the `return []` branch had
        // no .data for the render path to filter, so either one threw and took the submit
        // handler down with it.
        return await fetch(`/course/filter/search-suggestions?search=${encodeURIComponent(value)}`)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                }
                return null;
            })
            .then((data) => {
                if (data && data.success && Array.isArray(data.data)) {
                    return data;
                }
                return { success: false, data: [] };
            })
            .catch(() => ({ success: false, data: [] }));
    }
});

